export default {
    Default: "未設定",
    Urgent: "URGENT",
    Priority: "PRIORITY",
    Routine: "ROUTINE"
}